import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";



export const SectionChildren = styled.div`
  @media (max-width: ${defaultBreakpoints.medium}) {
    position: absolute;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    background: #f7f7f7;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    margin: 5px;
    margin-left: 10px;
    margin-right: 10px;
    padding: 5px;

    left: 0;
    right: 0;
  }
`;